import { Button, Typography } from "design_system/src";
import React, { useRef } from "react";
import ReactGA from "react-ga4";
import VerticalStepScrolling from "components/verticalStepScrolling/VerticalStepScrolling";
import { Link } from "react-router-dom";
import FinancingStepCard, { FinancingStepCardData } from "./FinancingStepCard";

const items: FinancingStepCardData[] = [
  {
    step: "Paso 1",
    title: "Solicita tu crédito",
    description: <Typography weight="400" scale="heading4" scaleMobile="large" className="m_b_sm">
        No necesitas historial crediticio. Completa el <strong className="text_primary_300">formulario</strong> y sube la documentación necesaria.
      </Typography>,
    imageUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Mobile/paso_1_solicita_tu_credito_financia_moto_ozon",
    imageDesktopUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Desktop/paso_1_solicita_tu_credito_financia_moto_en_pocos_minutos_ozon",
    imageAlt: "Paso 1 – Solicita tu crédito en 5 minutos con Ozon",
  },
  {
    step: "Paso 2",
    title: "Validamos tu crédito",
    description: <Typography weight="400" scale="heading4" scaleMobile="large">
      <strong>En cuanto recibamos tus documentos,</strong> revisaremos tu información para <strong>validar tu crédito.</strong> Una vez aprobado, definiremos el <strong>monto semanal de pago.</strong>
    </Typography>,
    imageUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Mobile/paso_2_validamos_tu_credito_hombre_feliz_small",
    imageDesktopUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Desktop/paso_2_validamos_tu_credito_financia_moto_ozon",
    imageAlt: "Crédito aprobado en 48 horas",
  },
  {
    step: "Paso 3",
    title: "Escoge tu moto",
    description: <>
      <Typography weight="400" scale="heading4" scaleMobile="large" className="m_b_sm">
        <strong>Elige entre motos nuevas y seminuevas</strong> en nuestro catálogo.
      </Typography>
      <Typography weight="400" scale="heading4" scaleMobile="large">
        Una vez elijas tu moto, podrás seleccionar el valor del enganche y el plan de pagos disponibles según la <strong>pre oferta</strong> que hayas recibido.
      </Typography>
    </>,
    imageUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Mobile/paso_3_escoge_tu_moto_financiamiento_small",
    imageDesktopUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Desktop/paso_3_escoge_tu_moto_financia_moto_ozon",
    imageAlt: "Tu nueva moto te espera",
  },
  {
    step: "Paso 4",
    title: "Recoge tu moto",
    description: <>
      <Typography weight="400" scale="heading4" scaleMobile="large">
        El día de la entrega solo debes <strong>firmar tu contrato, pagar tu enganche y llevarte tu moto.</strong> ¡Así de fácil!
      </Typography>
      <Link to="/financia-tu-moto" className="m_t_md">
        <Button className="w_100_per_mobile" onClick={() => {
          ReactGA.event("CTA_Home_go_to_ff", {
            category: "Home",
            label: "click in CTA to go to financial form",
          });
        }}>
          <Typography
            scale="medium"
            weight="600"
          >
            Solicita tu crédito ya
          </Typography>
        </Button>
      </Link>
    </>,
    imageUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Mobile/paso_4_recoge_tu_moto_hombre_financiamiento_small",
    imageDesktopUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Desktop/paso_4_recoge_tu_moto_financia_moto_ozon",
    imageAlt: "Entrega inmediata",
  }
];

const FinancingStepsSection: React.FC = () => {
  const financingStepsSectionRef = useRef<HTMLDivElement>(null);

  return (
    <section className="dso_container p_y_md">
      <VerticalStepScrolling
        key="Steps"
        name="financial-steps"
        sectionRef={financingStepsSectionRef}
        title={
          <Typography
            scale="heading1"
            scaleMobile="heading3"
            weight="600"
            component="h2"
            className="m_none p_y_md p_y_xl_desktop"
          >
            Financia tu moto con Ozon
          </Typography>
        }
        data={items.map((item) =>
          <FinancingStepCard key={`Step-${item.step}`} {...item} />
        )}
      />
    </section>
  );
};

export default FinancingStepsSection;
